import styled from 'styled-components'
import React from 'react'

import { themeGet } from '@styled-system/theme-get'

export interface ExtraResourcesListProps {
	type: number
}

export const ExtraResourcesWrapper = styled.span`
	font-size: 16px;
	line-height: 1.5;
	padding: 4px 8px;
	border-radius: 3px;
	height: 32px;
	display: inline-block;
	font-weight: 600;
	&.type10 {
		color: ${(props) => props.theme.new.colors.sol_yellow_400};
		border: 1px solid ${(props) => props.theme.new.colors.sol_yellow_100};
	}
	//교사용
	&.type20 {
		color: ${(props) => props.theme.new.colors.sol_mint_400};
		border: 1px solid ${(props) => props.theme.new.colors.sol_mint_100};
	}
	//해설지
	&.type30 {
		color: ${(props) => props.theme.new.colors.sol_blue_400};
		border: 1px solid ${(props) => props.theme.new.colors.sol_blue_100};
	}
	//부가자료
	&.type40 {
		color: ${(props) => props.theme.new.colors.sol_gray_400};
		border: 1px solid ${(props) => props.theme.new.colors.sol_gray_100};
	}
	@media (max-width: 768px) {
		font-size: 14px;
	}
`
const enum ExtraResourcesType {
	Student = 10,
	Teacher = 20,
	Explanation = 30,
	Extra = 40,
}
const ExtraResourceString = {
	[ExtraResourcesType.Teacher]: '교사용',
	[ExtraResourcesType.Student]: '학생용',
	[ExtraResourcesType.Extra]: '부가자료',
	[ExtraResourcesType.Explanation]: '해설지',
}
export const ExtraResourceNew: React.FC<ExtraResourcesListProps> = ({ type }) => (
	<ExtraResourcesWrapper className={`type${type}`}>
		{ExtraResourceString[type]}
	</ExtraResourcesWrapper>
)
//10:학생용, 20:선생용, 30:해설지, 40:부가자료
